import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ChevronRight, Play, X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonAutoplayBoxStyle, IconBoxStyle, ProgressBoxStyle } from "./ButtonAutoplayBox.styles";
import { useAutoplayProgress } from "./useAutoplayProgress";

interface ButtonAutoplayDesktop {
  duration:number,
  hideCountDownButton:() => void,
  playbackStatus:string,
  startNextVideo:() => void,
  onEndAction?:() => void
}

export function ButtonAutoplayDesktop({
  duration,
  hideCountDownButton,
  playbackStatus,
  startNextVideo,
  onEndAction
}:ButtonAutoplayDesktop){

  const theme = useTheme();
  const { t } = useTranslation();

  const [isHovered, setIsHovered] = useState(false);
  const progress = useAutoplayProgress({ duration, playbackStatus, startNextVideo });

  return (
    <ButtonAutoplayBoxStyle
      onMouseEnter={ () => setIsHovered(true) }
      onMouseLeave={ () => setIsHovered(false) }
      onClick={ () =>{
        hideCountDownButton();
        if(onEndAction && playbackStatus === "stop") { onEndAction() }
      }  } >
      <ProgressBoxStyle
        id="progress-box"
        progress={ progress }
      >
        <Box sx={ {
          alignItems: "center",
          display: "flex",
          gap: "8px",
          justifyContent: "space-between",
          padding: "0 16px"
        } }>
          <Box sx={ { display: "grid" } }>
            { /* le due label sono sovrapposte nella stessa cella della grid: la larghezza del bottone
                 resta quella della piu' lunga tra le due, evitando che cambi al passaggio del mouse */ }
            <Typography
              sx={ {
                color: theme.customColors.textPrimaryCta,
                fontSize: "14px",
                fontWeight: "600",
                gridArea: "1 / 1",
                opacity: isHovered ? 0 : 1,
                pointerEvents: "none",
                transition: "opacity 0.15s ease",
                whiteSpace: "nowrap"
              } }
            >
              { t("label_autoplay") }
            </Typography>
            <Typography
              sx={ {
                color: theme.customColors.textPrimaryCta,
                fontSize: "14px",
                fontWeight: "600",
                gridArea: "1 / 1",
                opacity: isHovered ? 1 : 0,
                pointerEvents: "none",
                transition: "opacity 0.15s ease",
                whiteSpace: "nowrap"
              } }
            >
              { t("close") }
            </Typography>
          </Box>
          <IconBoxStyle>
            { isHovered ?
              <X size={ 16 } color={ theme.customColors.textPrimaryCta }/> :
              progress >= 100 ?
                <ChevronRight size={ 16 } color={ theme.customColors.textPrimaryCta }/> :
                <Play size={ 16 } color={ theme.customColors.textPrimaryCta }/>
            }
          </IconBoxStyle>
        </Box>
      </ProgressBoxStyle>
    </ButtonAutoplayBoxStyle>
  );
}
